import { HStack, Icon, Stack, Text } from '@chakra-ui/react';
import { ChevronRightIcon } from '@heroicons/react/outline';
import { NoticeProps, OptionProps, chakraComponents } from 'chakra-react-select';
import { useTranslations } from 'use-intl';

import { CompanyOption, CompanyOptionGroup } from './types';

export function Option({
  children,
  ...props
}: OptionProps<CompanyOption, false, CompanyOptionGroup>): JSX.Element {
  return (
    <chakraComponents.Option {...props}>
      <HStack justifyContent="space-between" w="full">
        <Stack spacing="0">
          <Text fontWeight="semibold">{children}</Text>
          <HStack>
            <Text fontSize="sm">{props.data?.address?.city}</Text>
            <Text fontSize="sm"> - </Text>
            <Text fontSize="sm">{props.data.registrationNumber}</Text>
          </HStack>
        </Stack>
        <Icon as={ChevronRightIcon} />
      </HStack>
    </chakraComponents.Option>
  );
}

export function NoOptionsMessage({ ...props }: NoticeProps<CompanyOption>): JSX.Element {
  const i18nSearchCompanySelect = useTranslations('SearchCompanySelect');

  return (
    <chakraComponents.NoOptionsMessage {...props}>
      {i18nSearchCompanySelect('NoOptionsMessage')}
    </chakraComponents.NoOptionsMessage>
  );
}

export function LoadingMessage({ ...props }: NoticeProps<CompanyOption>): JSX.Element {
  const i18nSearchCompanySelect = useTranslations('SearchCompanySelect');

  return (
    <chakraComponents.LoadingMessage {...props}>
      {i18nSearchCompanySelect('LoadingMessage')}
    </chakraComponents.LoadingMessage>
  );
}

export const components = {
  LoadingMessage,
  NoOptionsMessage,
  Option,
};
